export const ctrInstitutionPrimaryFederalRegulators = [
    { label: 'Federal Reserve Board (FRB)', value: 'Federal Reserve Board (FRB)' },
    { label: 'Federal Deposit Insurance Corporation (FDIC)', value: 'Federal Deposit Insurance Corporation (FDIC)' },
    { label: 'Internal Revenue Service (IRS)', value: 'Internal Revenue Service (IRS)' },
    { label: 'National Credit Union Administration (NCUA)', value: 'National Credit Union Administration (NCUA)' },
    { label: 'Office of the Comptroller of the Currency (OCC)', value: 'Office of the Comptroller of the Currency (OCC)' },
    { label: 'Commodities Futures Trading Commission (CFTC)', value: 'Commodities Futures Trading Commission (CFTC)' },
    { label: 'Securities and Exchange Commission (SEC)', value: 'Securities and Exchange Commission (SEC)' }
]

export const ctrLocationPrimaryFederalRegulators = [
    { label: 'Federal Reserve Board (FRB)', value: 'Federal Reserve Board (FRB)' },
    { label: 'Federal Deposit Insurance Corporation (FDIC)', value: 'Federal Deposit Insurance Corporation (FDIC)' },
    { label: 'Internal Revenue Service (IRS)', value: 'Internal Revenue Service (IRS)' },
    { label: 'National Credit Union Administration (NCUA)', value: 'National Credit Union Administration (NCUA)' },
    { label: 'Office of the Comptroller of the Currency (OCC)', value: 'Office of the Comptroller of the Currency (OCC)' },
    { label: 'Commodities Futures Trading Commission (CFTC)', value: 'Commodities Futures Trading Commission (CFTC)' },
    { label: 'Securities and Exchange Commission (SEC)', value: 'Securities and Exchange Commission (SEC)' },
    { label: 'Unknown', value: 'Unknown' }
]

export const sarPrimaryFederalRegulators = [
    { label: 'Federal Reserve Board (FRB)', value: 'Federal Reserve Board (FRB)' },
    { label: 'Federal Deposit Insurance Corporation (FDIC)', value: 'Federal Deposit Insurance Corporation (FDIC)' },
    { label: 'Internal Revenue Service (IRS)', value: 'Internal Revenue Service (IRS)' },
    { label: 'National Credit Union Administration (NCUA)', value: 'National Credit Union Administration (NCUA)' },
    { label: 'Office of the Comptroller of the Currency (OCC)', value: 'Office of the Comptroller of the Currency (OCC)' },
    { label: 'Commodities Futures Trading Commission (CFTC)', value: 'Commodities Futures Trading Commission (CFTC)' },
    { label: 'Securities and Exchange Commission (SEC)', value: 'Securities and Exchange Commission (SEC)' },
    { label: 'Federal Housing Finance Agency (FHFA)', value: 'Federal Housing Finance Agency (FHFA)' },
    { label: 'Not Applicable', value: 'Not Applicable' }
]
